import { useNavigate } from 'react-router-dom';
import HeroSection from "../components/Common/HeroSection";
import MentalHealthCTA from "../components/Home/section2";
import OurClients from "../components/Home/reviewSection";
import LocationsBanner from "../components/Home/LocationsBanner";
import DiscoverMentalHealth from "../components/Home/DiscoverMentalHealth";

const Home = () => {
  const navigate = useNavigate();
  
  const handleBookAppointment = () => {
    navigate('/book-appointment');
  };

  const heroButtons = [
   {
      label: 'Book Appointment',
      className: 'btn-secondary',
      onClick: handleBookAppointment
    },
  ];

  const focusAreas = [
    {
      id: 1,
      image: '/assets/home/card1.svg',
      title: 'Hidden Distress',
      description: 'Many individuals mask early signs of emotional struggle until it reaches a breaking point.'
    },
    {
      id: 2,
      image: '/assets/home/card2.svg',
      title: 'Limited Access',
      description: 'Shortage of trained professionals and long wait times make timely care difficult.'
    },
    {
      id: 3,
      image: '/assets/home/card3.svg',
      title: 'Disconnected Data',
      description: 'Behavioral health information often remains separate from primary-care systems, limiting holistic insight.'
    },
    {
      id: 4,
      image: '/assets/home/card4.svg',
      title: 'Low Engagement',
      description: 'Existing digital solutions struggle to maintain consistent participation or follow-through.'
    },
    {
      id: 5,
      image: '/assets/home/card5.svg',
      title: 'Stigma & Awareness Gaps',
      description: 'Social stigma and lack of early education discourage people from seeking help.'
    },
    {
      id: 6,
      image: '/assets/home/card6.svg',
      title: 'Reactive Care Models',
      description: 'Most systems respond after symptoms worsen, rather than focusing on early detection and prevention.'
    },
  ];

  return (
    <div>
      <HeroSection
        backgroundImage='/assets/home/hero.png'
        title="Supporting Your Mental Health, Every Step of the Way"
        subtitle="Find a qualified counselor or mental health practitioner who’s right for you."
        buttons={heroButtons}
        textAlign="center"
        height="h-screen"
        titleSize="text-4xl"
      />
    
    <MentalHealthCTA
      title="Mental Health Professionals for Every Age"
      description="At Behavioral Health Clinic, you'll find the highest quality, state-of-the-art mental health services for individuals of any age. Our licensed psychologists and psychotherapists provide a variety of counseling services to children, adolescents, adults, families, and couples. Getting started is simple; visit our team page to find counselors who best fit your care needs."
      buttonText="Meet Our Caring Team"
      onButtonClick={() => console.log('Custom action')}
    />

    <LocationsBanner
      text="We offer flexible online and in-person behavioral health consultations in safe, confidential clinic settings across key locations in India, making quality mental health care accessible and convenient."
    />
    {/* <div className="h-8 md:h-12 lg:h-16 bg-white"></div> */}

    <DiscoverMentalHealth 
      focusAreas={focusAreas} 
    />

    <OurClients />

    </div>
  );
};

export default Home;